var _style, _defs, _defs2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupomConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331 93.3",
    style: {
      enableBackground: "new 0 0 331 93.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000036972107670293854770000016685443698861294259_);}\n\t.st1{clip-path:url(#SVGID_00000135693361067442033890000010609143188350472335_);}\n\t.st2{fill:#25DFE8;}\n\t.st3{fill:#0FB8CB;}\n\t.st4{fill:#EFBB2B;}\n\t.st5{fill:none;}\n\t.st6{fill:#F7D665;}\n\t.st7{fill:#8A3CE5;}\n\t.st8{fill:#FB639E;}\n\t.st9{fill:#F32874;}\n\t.st10{fill:#FF5A9D;}\n\t.st11{fill:#00D08F;}\n\t.st12{fill:#00B77A;}\n\t.st13{fill:#10B9BC;}\n\t.st14{fill:#FBD45D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 331,
    height: 93
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032637977339086806290000011202034190659971742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    style: {
      clipPath: "url(#SVGID_00000032637977339086806290000011202034190659971742_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003091298619395555770000016387269012359343261_",
    x: 0,
    y: -62,
    width: 500,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170979099452328257810000007964240805689550233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003091298619395555770000016387269012359343261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170979099452328257810000007964240805689550233_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.3,175c1.1,0,2.2,0,3.3-0.1c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c2.7-0.1,5.6-0.5,8-1.3 c1-0.3,1.9-0.7,2.8-1.2c3.8,1.2,8,1.5,11.8,1.5c0.7,0,1.3,0,2-0.1c0,0,0,0,0,0c0,0,0,0,0,0c9-0.5,17.4-4,21.7-12.5h-8.7 c-2.6,5.1-6.9,8.8-12.2,11c-1.2,0.5-2.4,0.8-3.7,1.1c-0.4-0.1-0.8-0.2-1-0.2c-2.3-0.6-4.3-1.8-6.1-3.2 c4.1-3.4,6.9-8.3,6.9-13.8c0-3.1-0.3-7.4-3.4-9c-0.4-0.2-0.9-0.4-1.5-0.5c0,0,0,0,0.1,0c-2.9-0.7-4.6-0.2-6.5,0 c-0.9,0.1-1.7,0.2-2.4,0.2c-6.6,0.2-8.7,10-7.6,14.9c0.9,3.8,2.9,6.4,5.5,8.3c-2,1.6-4.2,2.8-6.5,3.7 c-0.8,0.3-1.6,0.5-2.5,0.7c-0.7-0.1-1.3-0.3-1.6-0.4c-2.1-0.7-3.9-2-5.4-3.6c2.3-1.7,4.1-4.1,5-7c1.1-4.1-3-5.6-6.2-5.6 c-3.4,0-10.6-1.5-12.2,2.8c-1.2,3.3,1.4,7,4.6,9.8c-1.2,1-2.4,1.7-3.3,2.2c-1.1,0.5-2.3,0.9-3.5,1.1 c-0.4-0.1-0.8-0.1-1.3-0.2c-4-0.7-7.9-2.2-11.6-3.8c-6.2-2.7-12.2-6.3-17.6-10.4h-8.7c6.4,4.8,13.4,8.7,20.7,11.7 c5.2,2.1,10.3,2.9,15.6,3.1c-0.2,0,0.1,0,0.7,0c2.2,0.1,4.5,0.1,6.8,0c1.9-0.1,3.9-0.4,5.8-1c1,0.6,1.9,1,2.7,1.3 C209.3,175.3,212,175,215.3,175z M228,154.1c0.5-1.5,1.4-3.3,2.6-4.7c1.5,3,1.2,7.9,0.7,10.4c-0.4,1.9-1.1,3.6-2.1,5.2 C227.3,161.7,226.9,157.8,228,154.1z M204.6,159.4c0.7,0.2,1.3,0.4,1.4,0.8c0.5,1.6-0.2,3.4-1.3,5.2 C203.7,163.3,203.3,161,204.6,159.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,161.3h-8.7c-2.6,5.1-6.9,8.8-12.2,11c-1.2,0.5-2.4,0.8-3.7,1.1c1,0.2,2.2,0.4,2.9,0.5 C252.5,173.4,260.9,169.8,265.1,161.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.3,159.9c0.3,0.4,0.5,0.8,0.6,1.3c0.4,1.2,0.1,2.5-0.4,3.7c0.4,0.9,1,1.8,1.5,2.5 c0.8,1,1.6,2,2.5,2.9c2.3-1.7,4.1-4.1,5-7c1.1-4.1-3-5.6-6.2-5.6c0,0-0.1,0-0.1,0c-0.5,0.2-1.1,0.4-1.6,0.7 C205.1,158.9,204.6,159.4,204.3,159.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.9,174c-0.2,0-0.5,0-0.7,0C190,174,190.3,174,190.9,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M196.5,172.5c-1.1,0.5-2.3,0.9-3.5,1.1c0.6,0.1,1.2,0.2,1.8,0.2c-1.9,0.1-3.2,0.1-3.9,0.2 c2.2,0.1,4.5,0.1,6.8,0c1.9-0.1,3.9-0.4,5.8-1c-1.2-0.7-2.5-1.6-3.7-2.6C198.6,171.3,197.4,172.1,196.5,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.2,174c-0.6-0.1-3.6-0.3-4.2-0.4c-0.4-0.1-0.8-0.1-1.3-0.2c-4-0.7-7.9-2.2-11.6-3.8 c-6.2-2.7-12.2-6.3-17.6-10.4h-8.7c6.4,4.8,13.4,8.7,20.7,11.7c5.2,2.1,9.9,3,15.2,3.2c0.2,0,0.5,0,0.7,0 C192.3,174.3,195.3,174.1,197.2,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.4,173.8C243.4,173.8,243.4,173.8,243.4,173.8C243.4,173.8,243.4,173.8,243.4,173.8 C243.4,173.8,243.4,173.8,243.4,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.8,173.6c1-0.3,1.9-0.7,2.8-1.2c-1.8-0.6-3.5-1.4-5.1-2.4c-2,1.6-4.2,2.8-6.5,3.7 c-0.8,0.3-1.6,0.5-2.5,0.7l2.5,0.6C221.1,174.9,223.9,174.6,226.8,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.4,173.8c-3.8,0.1-5.5-0.1-3.3-0.4c0.1,0,0.3-0.1,0.4-0.1c-0.4-0.1-0.8-0.2-1-0.2 c-2.3-0.6-4.3-1.8-6.1-3.2c-0.7-0.6-1.4-1.2-2-1.9c-0.9-0.9-1.6-1.9-2.2-3c-1.8-3.3-2.2-7.2-1.1-10.9 c0.5-1.5,1.4-3.3,2.6-4.7c1.3-1.6,3-2.7,4.9-2.8c-1.9-0.4-4.3-0.6-6.4-0.4c-0.9,0.1-1.7,0.2-2.4,0.2 c-6.6,0.2-8.7,10.3-7.6,15.3c0.9,3.8,2.9,6.4,5.5,8.3c1.5,1.1,3.2,1.9,5.1,2.4c3.8,1.2,8,1.5,11.8,1.5 C242.1,173.9,242.7,173.9,243.4,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M235.4,146.6C235.4,146.6,235.5,146.6,235.4,146.6c-2.8-0.7-4.6-0.3-6.4,0 C231.1,146.4,233.5,146.2,235.4,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.4,173.8C243.4,173.8,243.4,173.8,243.4,173.8c-0.7-0.1-1.9-0.3-2.9-0.5c-0.1,0-0.3,0.1-0.4,0.1 C237.9,173.8,239.6,173.9,243.4,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.5,149.4c1.5,3,1.2,7.9,0.7,10.4c-0.4,1.9-1.1,3.6-2.1,5.2c0.6,1.1,1.3,2.1,2.2,3 c0.6,0.7,1.3,1.3,2,1.9c4.1-3.4,6.9-8.3,6.9-13.8c0-3.1-0.3-7.4-3.4-9c-0.4-0.2-0.9-0.4-1.5-0.5 C233.5,146.7,231.9,147.8,230.5,149.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.2,274.7c0.9,0.6,1.8,1.3,2.7,1.9c0.1,0.1,0.2,0.1,0.2,0.1c0,0,0,0,0,0c2.3,1.5,4.8,2.9,7.2,3.7 c1,0.3,2,0.5,3,0.7c2.3,3.2,5.5,6,8.6,8.2c0.5,0.4,1.1,0.8,1.6,1.1c0,0,0,0,0,0c0,0,0,0,0,0c7.5,5,16.4,7.1,24.9,2.8l-7-5.2 c-5.1,2.6-10.8,3-16.3,1.6c-1.2-0.3-2.4-0.8-3.6-1.3c-0.3-0.3-0.5-0.6-0.7-0.8c-1.5-1.8-2.4-4-3-6.2c5.3-0.3,10.5-2.6,13.8-7 c1.8-2.5,4.2-6.2,2.6-9.3c-0.2-0.4-0.5-0.9-0.9-1.3c0,0,0,0,0.1,0c-1.9-2.3-3.6-2.9-5.2-3.8c-0.8-0.5-1.5-0.9-2-1.3 c-5.5-3.8-12.9,2.9-14.9,7.5c-1.5,3.6-1.5,6.9-0.5,9.9c-2.5,0.1-5.1-0.3-7.4-0.9c-0.8-0.2-1.6-0.5-2.4-0.9 c-0.5-0.5-0.8-1-1-1.2c-1.3-1.8-1.9-3.9-2.3-6.1c2.9,0,5.7-0.8,8.2-2.7c3.3-2.6,0.9-6.2-1.7-8.2c-2.7-2-7.6-7.5-11.5-4.9 c-3,1.9-3,6.5-2.1,10.6c-1.6,0-3-0.1-4-0.2c-1.2-0.2-2.4-0.7-3.5-1.2c-0.3-0.3-0.6-0.6-0.9-0.9c-2.8-3-5-6.5-7.1-10 c-3.4-5.9-6-12.3-8-18.8l-7-5.2c2.3,7.6,5.6,15,9.8,21.7c2.9,4.7,6.6,8.4,10.7,11.8c-0.1-0.1,0,0.1,0.5,0.4 c1.8,1.4,3.6,2.7,5.5,4c1.6,1.1,3.4,2,5.3,2.6c0.5,1,0.9,1.9,1.4,2.6C325.3,271.4,327.6,272.8,330.2,274.7z M352.8,265.5 c1.3-1,3-1.9,4.9-2.3c-0.6,3.4-3.7,7.1-5.6,8.8c-1.4,1.3-3.1,2.2-4.8,2.9C347.8,271.2,349.7,267.8,352.8,265.5z M330.9,255.9 c0.4,0.5,0.8,1.1,0.7,1.5c-0.6,1.6-2.2,2.7-4.1,3.4C327.8,258.5,328.8,256.4,330.9,255.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.1,257.5c0.2-0.5,0.2-0.9,0.3-1.4c-1.6,0.7-2.4,2.4-2.8,4.2C328.7,259.6,329.6,258.7,330.1,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M357.7,263.2c-1.8,0.4-3.6,1.3-4.9,2.3c-3.1,2.3-5.1,5.7-5.6,9.5c1.8-0.7,3.4-1.6,4.8-2.9 C354,270.3,357.2,266.5,357.7,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.8,253.9c-0.1-0.1-0.1-0.3-0.2-0.4C328.2,251.4,327,251.9,329.8,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M378.4,293.3l-7-5.2c-5.1,2.6-10.8,3-16.3,1.6c-1.2-0.3-2.4-0.8-3.6-1.3c0.7,0.8,1.5,1.6,2.1,2.1 C361.1,295.5,370,297.7,378.4,293.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.1,254.7l0.5,0.1c0.4,0.7-0.3,0.5-0.3,1.3c0.6-0.2,1.2-0.4,2-0.3c0.5,0,1.1,0.2,1.7,0.4 c0,0-0.1-0.1-0.1-0.1c-1.7-0.8-3.2-1.5-4.1-2.1C329.8,253.8,330.2,254.8,330.1,254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.1,257.5c0.2-0.5,0.2-0.9,0.3-1.4c-1.6,0.7-2.4,2.4-2.8,4.2C328.7,259.6,329.6,258.7,330.1,257.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.3,256c0,0.5-0.1,1-0.3,1.4c-0.4,1.2-1.4,2.1-2.5,2.8c-0.2,1-0.3,2-0.3,3c0,1.3,0.1,2.6,0.3,3.9 c2.9,0,5.7-0.8,8.2-2.7c3.3-2.6,0.9-6.2-1.7-8.2c0,0-0.1,0-0.1-0.1c-0.5-0.2-1.2-0.3-1.7-0.4 C331.6,255.7,330.9,255.8,330.3,256z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.2,259.5c-0.2-0.1-0.4-0.3-0.5-0.4C310.5,259,310.7,259.1,311.2,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.6,261.6c-1.2-0.2-2.4-0.7-3.5-1.2c0.4,0.4,0.9,0.9,1.3,1.3c-1.6-1-2.7-1.8-3.3-2.2 c1.8,1.4,3.6,2.7,5.5,4c1.6,1.1,3.4,2,5.3,2.6c-0.6-1.3-1.1-2.7-1.4-4.3C319,261.9,317.6,261.8,316.6,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.2,263.2c-0.5-0.4-2.7-2.4-3.1-2.8c-0.3-0.3-0.6-0.6-0.9-0.9c-2.8-3-5-6.5-7.1-10 c-3.4-5.9-6-12.3-8-18.8l-7-5.2c2.3,7.6,5.6,15,9.8,21.7c2.9,4.7,6.2,8.3,10.3,11.6c0.2,0.1,0.4,0.3,0.5,0.4 C312.1,260.6,314.7,262.2,316.2,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M353.6,290.5C353.6,290.5,353.6,290.5,353.6,290.5C353.6,290.5,353.5,290.5,353.6,290.5 C353.5,290.5,353.6,290.5,353.6,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M340.3,280.4c1,0.3,2,0.5,3,0.7c-1.1-1.6-2-3.2-2.6-5c-2.5,0.1-5.1-0.3-7.4-0.9 c-0.8-0.2-1.6-0.5-2.4-0.9l1.7,2C335,278.1,337.4,279.5,340.3,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M353.5,290.5c-3.1-2.1-4.4-3.3-2.4-2.3c0.1,0.1,0.3,0.1,0.4,0.2c-0.3-0.3-0.5-0.6-0.7-0.8 c-1.5-1.8-2.4-4-3-6.2c-0.2-0.9-0.4-1.8-0.5-2.7c-0.2-1.3-0.2-2.5,0-3.8c0.5-3.7,2.5-7.1,5.6-9.5c1.3-1,3-1.9,4.9-2.3 c2-0.5,4-0.4,5.6,0.6c-1.3-1.4-3.1-3-4.9-4.1c-0.8-0.5-1.5-0.9-2-1.3c-5.5-3.8-13.1,3.1-15.1,7.8c-1.5,3.6-1.5,6.9-0.5,9.9 c0.6,1.8,1.5,3.4,2.6,5c2.3,3.2,5.5,6,8.6,8.2C352.4,289.7,353,290.1,353.5,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M357.7,263.2c-0.6,3.4-3.7,7.1-5.6,8.8c-1.4,1.3-3.1,2.2-4.8,2.9c-0.2,1.2-0.2,2.5,0,3.8 c0.1,0.9,0.3,1.8,0.5,2.7c5.3-0.3,10.5-2.6,13.8-7c1.8-2.5,4.2-6.2,2.6-9.3c-0.2-0.4-0.5-0.9-0.9-1.3 C361.7,262.8,359.7,262.7,357.7,263.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464.5,312.1C466,312.4,466.8,312,464.5,312.1L464.5,312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M473.2,311.8C474.8,312,475.5,311.6,473.2,311.8L473.2,311.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M489,303.1c-1.7,0.8-3.3,1.8-4.9,2.8c-2.7,1.7-5.5,3.5-8.5,4.8c2-0.8,3.9-1.7,5.7-2.8 c3-1.8,6.1-4.1,9.4-5.5c0,0,0,0,0,0C490.1,302.7,489.6,302.9,489,303.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M499.9,313.9c0.5,1.1,7.1-1,7.6,0c-2.4-4.8-5.6-10.9-11.4-12.2c-3.5-0.7-8.3-0.6-11.7,0.3 c-4.3,1-8,4.1-11.8,6.3c-2.2,1.3-4.5,2.5-7,3.3c-0.1,0-0.1,0-0.2,0.1l0,0c-0.5,0.1-1,0.3-1.4,0.4c-0.2,0-0.3-0.1-0.5-0.1 c-7.5-2.4-10.3-11.9-14.5-17.7c-1.1-1.6-2.5-2.9-4.1-3.9l-6.3,0.9c0.1,0.1,0.2,0.1,0.2,0.2c2.6,2.1,4.2,5.2,5.8,8 c3.5,6.1,7.3,12.9,15.2,13.2c0.8,0,1.7,0.1,2.5,0.1c0.1,0,0.1,0,0.2,0c0.9,0,1.7,0,2.6,0c0,0,0.1,0,0.2,0 c0.9,0,1.7,0,2.6-0.1c0,0,0.1,0,0.1,0c1.3-0.1,2.6-0.3,3.8-0.5c4.5-0.9,8.5-3.6,12.4-6.1c1.6-1,3.2-2,4.9-2.8 c0.5-0.3,1.1-0.5,1.7-0.7C495.1,304.4,497.9,310,499.9,313.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M463.5,311.9c-7.5-2.4-10.3-11.9-14.5-17.7c-1.1-1.6-2.5-2.9-4.1-3.9l-6.3,0.9 c0.1,0.1,0.2,0.1,0.2,0.2c2.6,2.1,4.2,5.2,5.8,8c3.5,6.1,7.3,12.9,15.2,13.2c0.8,0,1.7,0.1,2.5,0.1c0.1,0,0.1,0,0.2,0 c0.9,0,1.7,0,2.6,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c-0.6-0.2-1.3-0.4-1.8-0.7C463.6,311.9,463.5,311.9,463.5,311.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M494.6,305.4c2.3,2.5,4,5.9,5.3,8.5c0.5,1.1,7.1-1,7.6,0c-1.9-3.9-4.4-8.5-8.3-10.9 c-0.5,0.2-1,0.4-1.6,0.7C496.6,304.2,495.6,304.8,494.6,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M493,302.5c-0.5,0.1-0.9,0.3-1.4,0.4c1.1,0.6,2,1.5,2.9,2.4c1-0.6,2-1.2,3.1-1.7 c0.5-0.3,1-0.5,1.6-0.7c-0.8-0.5-1.6-0.8-2.4-1.1C495.5,302.1,494.2,302.3,493,302.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M507.5,313.9c-2.1-4.2-4.8-9.3-9.2-11.4c-0.7-0.3-1.4-0.6-2.2-0.8c-0.7-0.1-1.4-0.2-2.1-0.3 c-0.3,0.1-0.6,0.1-0.9,0.2c-0.8,0.2-1.6,0.5-2.4,0.8c1.2,0.6,2.3,1.4,3.3,2.4c2.6,2.6,4.4,6.3,5.8,9.1 C500.4,315,507,312.9,507.5,313.9z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.1,393.8c3.4-7.9,9.6-24.1,19.8-26.9c0,0,0,0,0,0c1.8,1.3,3.3,2.9,4.8,4.5c3.4,3.8,6.4,8,9.4,12 c5.2,7,8.4,14.3,17.2,16.6c2.4,1.1,10.5,3,11,2.8c2.6,0.4,5.1,0.4,7.6-0.5c5.6-2.1,9.6-7.8,12.8-12.6 c-0.6,1-9.8-3.6-10.5-2.5c-3.2,4.8-6.9,9.8-12.3,12.3c-0.7,0.3-1.5,0.6-2.2,0.7c0,0,0,0-0.1,0c-10.3-5.4-13.2-15.1-19.2-22.7 c-2.8-3.5-5.8-7-9.6-9.4c-2.5-1.6-5.6-2.5-8.8-3.2c-1.3-0.3-2.8-0.7-3.8-0.7c-1-0.2-2-0.3-3-0.4 c-12.3-1.6-20.1,19.1-23.7,27.3C301.7,390.8,311.8,394.4,312.1,393.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.7,392.9c-1.6-2.2-3.1-4.5-4.8-6.9c-3-4.1-5.9-8.3-9.4-12c-1.5-1.6-3-3.2-4.8-4.5c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0.1c3,2.3,5.5,5.2,7.8,8.2C354.2,382.5,357.6,388,361.7,392.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.1,393.8c3.2-7.5,9-22.4,18.3-26.4c1.8-0.8,3.7-1.2,5.8-0.9c0.5,0.1,1.1,0.2,1.6,0.2 c-1.8-0.7-3.7-1.3-5.6-1.7c-1.3-0.3-2.8-0.7-3.8-0.7c-1-0.2-2-0.3-3-0.4c-12.3-1.6-20.1,19.1-23.7,27.3 C301.7,390.8,311.8,394.4,312.1,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M380.3,402.8c0.5-0.1,1.1-0.3,1.6-0.5c5.6-2.1,9.6-7.8,12.8-12.6c-0.6,1-9.8-3.6-10.5-2.5 c-2.6,3.9-5.5,7.9-9.4,10.6c-0.9,0.6-1.8,1.2-2.8,1.7c-0.7,0.3-1.5,0.6-2.2,0.7c0,0,0,0-0.1,0c0,0,1.6,1.4,4.6,2.3 c0.2,0.1,0.4,0.2,0.6,0.2C376.6,403.2,378.5,403.2,380.3,402.8z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249,375.4c-9.2,7.3-16.3,17.2-12.8,29.4c0.1,0.5,5.2-0.4,5.3,0c-3.5-12.2,3.6-22.1,12.8-29.4 c-0.4,0.3-2.2,0-2.7,0C251.2,375.4,249.4,375.1,249,375.4L249,375.4z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456-25.1c-7.7,17.4-10.3,36.9,4,51.7c0.6,0.6,7.1-4.6,7.6-4.1c-14.3-14.8-11.7-34.3-4-51.7 c-0.3,0.7-3.2,1.7-3.8,2C459.1-26.8,456.3-25.9,456-25.1L456-25.1z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M491.8,375.8c-10.9-15.6-26.3-27.9-46.3-23.3c-0.8,0.2,0.2,8.5-0.5,8.6c20-4.6,35.4,7.8,46.3,23.3 c-0.4-0.6,0.2-3.6,0.3-4.3C491.6,379.3,492.3,376.4,491.8,375.8L491.8,375.8z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M427,109c0.2,4,1.2,8,4.4,10.3c-1.7,4.3-2.2,8.5-2.1,13.3c0,0,0.1,1.9,0.1,2.7c0.2,4.6,0.9,8.8,3.3,13 c3,5.4,8.2,9.3,13.4,12.5c-1.1-0.6,1-6.4-0.2-7.1c-6.9-4.2-13.1-9.6-15.6-17.5c-0.3-0.9-0.5-1.8-0.7-2.7c0,0,0-0.1,0-0.1 c0.1-1.3,0.3-2.6,0.7-3.9c0.8-2.5,2-4.9,3.2-7.1c0.3-0.5,0.6-1.1,0.9-1.6c3.4,0.9,7.3-0.2,10.3-1.8c2.9-1.5,4-3.2,4.3-5.9 c0.2-1.3,0.3-4.6,0.1-6c-0.1-0.6-0.2-1.1-0.5-1.6c-1.1-1.9-3.6-2.1-5.4-1.5c-3.8,1.3-6.7,5.5-8.9,9.4c-3.2-0.9-5.9-3.3-7-7.3 c0-0.2-0.1-0.3-0.1-0.5c0.2-1.3,0.7-2.5,1.2-3.8c1.3-2.9,3.4-5.4,5.7-7.5c4.9-4.6,11.3-7.6,17.8-9.3 c4.2-1.1,9.1-1.4,13.5-0.5c-0.3,1.4-0.4,2.8-0.5,4.2c0,1.2-0.1,1.7,0,2.6c0,3.7-0.3,7.5,3.7,9.2c2.8,1.1,6.4-0.1,8.1-2.5 c0.9-1.3,0.8-3,0.8-4.5c0-2.4,0.2-5.1-0.6-7.4c-0.8-2.3-2.5-4.2-4.6-5.7c1.7-1.4,3.6-2.5,5.7-3.3c9.6-3.7,21.5-0.2,29,6.4 c-0.3-0.3,0-3.1,0-3.6c0-0.5,0.3-3.2-0.1-3.6c-9.4-8.2-25.5-11.3-35.5-2.5c-1.4,1.3-2.6,2.7-3.5,4.3c-1.3-0.5-2.7-0.8-3.9-1 c-6.4-1.1-13.3,0.7-19.2,3.2c-6,2.5-11.5,6.6-15.1,12C426.3,97.4,426.8,103.2,427,109z M444.8,110.7c0.4-0.1,0.9,0,1.3,0.1 c-2,1.6-4.3,2.6-6.7,2.9C441,112.2,442.8,111,444.8,110.7z M476.1,91.4c-0.6,0.6-1.3,1.1-2,1.5c-2.1,1.2-4.9,1.1-7-0.2 c-0.7-0.5-1.2-1.1-1.5-1.8c0.3-1.1,0.7-2.2,1.2-3.2c0.3-0.8,0.8-1.6,1.2-2.4C471.3,86.4,474.2,88.4,476.1,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M448.6,105.4c-1.1-1.9-3.6-2.1-5.4-1.5c-3.8,1.3-6.7,5.5-8.9,9.4c-1.5,2.5-2.9,5.9-2.9,5.9 c-1.7,4.1-2.1,8.1-2.1,12.7c0.1,0.6,0.2,1.1,0.3,1.5c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1-1.3,0.3-2.6,0.7-3.9 c0.8-2.5,2-4.9,3.2-7.1c0.3-0.5,0.6-1.1,0.9-1.6c1.8-3.4,5-7,5-7c1.6-1.5,3.4-2.7,5.4-3c0.4-0.1,0.9,0,1.3,0.1 c1.1,0.2,2.2,1.4,2.9,2.2c0.2-1.3,0.3-4.5,0.1-6C449,106.5,448.9,105.9,448.6,105.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M427.4,106.2C427.4,106.2,427.4,106.2,427.4,106.2L427.4,106.2L427.4,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M444.8,80.3c-6,2.5-11.5,6.6-15.1,12c-2,3-2.6,6.2-2.8,9.4c0.1,1.6,0.3,3,0.4,3.8 c0.2-1.3,0.7-2.5,1.2-3.7c1.3-2.9,3.4-5.4,5.7-7.5c4.9-4.6,11.3-7.6,17.8-9.3c4.2-1.1,9.1-1.4,13.5-0.5 c0.8,0.2,1,0.2,2.6,0.7c3.3,1.1,6.1,3.1,8.1,6.2c0.8,1,1.2,2.5,1.4,3.8c0-0.6,0-1.2,0-1.8c0-2.4,0.2-5.1-0.6-7.4 c-0.8-2.3-2.5-4.2-4.6-5.7c-1.9-1.2-4.4-2.3-4.4-2.3c-1.3-0.5-2.7-0.8-3.9-1C457.5,76.1,450.7,77.8,444.8,80.3z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M282.2,55.6c0.2,4.1,1.2,8.3,4.5,10.7c-1.8,4.4-2.3,8.8-2.2,13.7c0,0,0.1,2,0.1,2.8 c0.2,4.7,0.9,9.1,3.4,13.4c3.1,5.6,8.5,9.6,13.9,12.9c-1.1-0.7,1-6.6-0.2-7.4c-7.1-4.3-13.5-9.9-16.1-18 c-0.3-0.9-0.5-1.9-0.7-2.8c0,0,0-0.1,0-0.1c0.1-1.3,0.3-2.7,0.8-4c0.8-2.6,2.1-5,3.3-7.4c0.3-0.5,0.6-1.1,0.9-1.7 c3.5,0.9,7.5-0.2,10.6-1.8c3-1.6,4.2-3.3,4.5-6c0.2-1.3,0.3-4.7,0.1-6.2c-0.1-0.6-0.2-1.2-0.5-1.7c-1.1-1.9-3.7-2.2-5.6-1.5 c-3.9,1.3-6.9,5.7-9.1,9.7c-3.3-1-6.1-3.4-7.2-7.5c0-0.2-0.1-0.3-0.1-0.5c0.2-1.3,0.7-2.6,1.2-3.9c1.3-3,3.5-5.5,5.9-7.8 c5-4.8,11.7-7.9,18.4-9.6c4.3-1.1,9.3-1.5,13.9-0.5c-0.3,1.4-0.5,2.9-0.5,4.3c0,1.2-0.1,1.8,0,2.7c0,3.8-0.3,7.8,3.8,9.5 c2.9,1.2,6.6-0.1,8.3-2.6c1-1.4,0.8-3.1,0.8-4.6c0-2.5,0.2-5.3-0.6-7.6c-0.8-2.4-2.6-4.4-4.8-5.9c1.8-1.4,3.8-2.6,5.9-3.4 c9.9-3.8,22.2-0.2,29.9,6.6c-0.3-0.3,0-3.2,0-3.7c0-0.5,0.3-3.3-0.1-3.7c-9.7-8.4-26.3-11.6-36.6-2.6 c-1.5,1.3-2.7,2.8-3.6,4.5c-1.4-0.5-2.7-0.9-4-1.1c-6.6-1.1-13.7,0.7-19.8,3.3c-6.1,2.6-11.9,6.8-15.6,12.4 C281.4,43.6,282,49.6,282.2,55.6z M300.6,57.4c0.4-0.1,0.9,0,1.4,0.1c-2.1,1.6-4.5,2.6-6.9,3 C296.6,58.9,298.5,57.7,300.6,57.4z M332.9,37.5c-0.6,0.6-1.3,1.2-2,1.6c-2.2,1.2-5.1,1.1-7.2-0.3c-0.7-0.5-1.2-1.1-1.6-1.9 c0.3-1.1,0.8-2.3,1.2-3.3c0.4-0.9,0.8-1.7,1.3-2.5C327.9,32.3,330.8,34.3,332.9,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M304.5,51.9c-1.1-1.9-3.7-2.2-5.6-1.5c-3.9,1.3-6.9,5.7-9.1,9.7c-1.5,2.6-3,6.1-3,6.1 c-1.7,4.2-2.2,8.4-2.2,13.1c0.1,0.6,0.2,1.1,0.3,1.6c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1-1.3,0.3-2.7,0.8-4 c0.8-2.6,2.1-5,3.3-7.4c0.3-0.5,0.6-1.1,0.9-1.7c1.9-3.5,5.2-7.2,5.2-7.2c1.6-1.6,3.5-2.8,5.6-3.1c0.4-0.1,0.9,0,1.4,0.1 c1.1,0.2,2.3,1.4,3,2.3c0.2-1.3,0.3-4.7,0.1-6.2C304.9,53,304.7,52.4,304.5,51.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M282.6,52.7C282.6,52.7,282.6,52.7,282.6,52.7L282.6,52.7L282.6,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M300.5,26c-6.1,2.6-11.9,6.8-15.6,12.4c-2,3.1-2.7,6.3-2.9,9.7c0.1,1.7,0.3,3.1,0.4,3.9 c0.2-1.3,0.7-2.6,1.2-3.8c1.3-3,3.5-5.5,5.9-7.8c5-4.8,11.7-7.9,18.4-9.6c4.3-1.1,9.3-1.5,13.9-0.5c0.9,0.2,1,0.2,2.7,0.7 c3.4,1.2,6.3,3.2,8.3,6.4c0.8,1.1,1.2,2.6,1.4,3.9c0-0.6,0-1.2,0-1.8c0-2.5,0.2-5.3-0.6-7.6c-0.8-2.4-2.6-4.4-4.8-5.9 c-2-1.3-4.5-2.3-4.5-2.3c-1.4-0.5-2.7-0.9-4-1.1C313.7,21.6,306.6,23.4,300.5,26z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M491.4,108.2c0,0-4.5,15.7-23.2,21.4c-0.3-4.2-3-8.1-3-8.1s20.2-7.5,17.5-20.5 C486,101.6,491.4,108.2,491.4,108.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.1,206.7c0,0-10.5-3.8-13.5-16.8c2.9,0,5.7-1.7,5.7-1.7s4.2,14.1,13.1,12.9 C460.9,203.3,456.1,206.7,456.1,206.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M421.5,0.4c0,0-10.5-3.8-13.5-16.8c2.9,0,5.7-1.7,5.7-1.7S417.9-4,426.8-5.2 C426.2-3,421.5,0.4,421.5,0.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M471.6-40.9c0,0,6.1-22.3,32.5-30.7c0.5,6,4.4,11.5,4.4,11.5s-28.5,11-24.4,29.3 C479.4-31.6,471.6-40.9,471.6-40.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M396.4,179.3c0,0,7.7-5.1,8.6-8.4c-5.8,0.7-10.3-2.3-13.7-6.1l-7.5,5.8 C389.9,177,396.4,179.3,396.4,179.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.5,14.3c0,0,7.8,4.8,11.3,4.2c-3.1-4.9-2.3-10.3-0.3-15L387-0.9C383.7,7.4,384.5,14.3,384.5,14.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M377.1,91.3c-5.1-5.8-7.5-13.4-7.5-13.4s-4.5,2.5-9.2,2.5c1.9,7.4,5.4,12.9,9.1,16.8L377.1,91.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "423.2,54.4 442.9,69.9 416.7,72  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "412.1,-57.5 444.6,-33.1 405.6,-39.9  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "351.8,129.6 361.1,137.7 351.8,141.3  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "462.2,167.8 474.8,169.6 468.5,176.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "483.7,26.1 496.3,27.9 490,34.8  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "360.6,-21.9 366.7,-33.1 379.3,-21.9  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "411.4,147.7 417.5,136.5 423.4,155.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "340.1,433.5 346.1,422.2 352.1,441.6  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "282.3,382 292.1,390.2 272,392.2  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M401.9,300c0,0,15.7,4.5,21.4,23.2c-4.2,0.3-8.1,3-8.1,3s-7.5-20.2-20.5-17.5 C395.2,305.5,401.9,300,401.9,300z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M482.9,418.8c0,0,15.7,4.5,21.4,23.2c-4.2,0.3-8.1,3-8.1,3s-7.5-20.2-20.5-17.5 C476.3,424.2,482.9,418.8,482.9,418.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M509,344.9c0,0-3.8,10.5-16.8,13.5c0-2.9-1.7-5.7-1.7-5.7s14.1-4.2,12.9-13.1 C505.6,340.2,509,344.9,509,344.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M289.2,360.1c0,0-22.3-6.1-30.7-32.5c6-0.5,11.5-4.4,11.5-4.4s11,28.5,29.3,24.4 C298.5,352.3,289.2,360.1,289.2,360.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M484.5,395.9c0,0-5.1-7.7-8.4-8.6c0.7,5.8-2.3,10.3-6.1,13.7l5.8,7.5 C482.2,402.4,484.5,395.9,484.5,395.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M496.1,239.4c0,0,8-4.5,9.2-7.8c-5.8,0.3-10.1-3-13.2-7.1l-7.9,5.2C489.7,236.7,496.1,239.4,496.1,239.4z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.5,427.9c0,0,4.8-7.8,4.2-11.3c-4.9,3.1-10.3,2.3-15,0.3l-4.4,8.5 C307.6,428.7,314.5,427.9,314.5,427.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M396.5,415.2c-5.8,5.1-13.4,7.5-13.4,7.5s2.5,4.5,2.5,9.2c7.4-1.9,12.9-5.4,16.8-9.1L396.5,415.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M383.1,202.4c-5.8,5.1-13.4,7.5-13.4,7.5s2.5,4.5,2.5,9.2c7.4-1.9,12.9-5.4,16.8-9.1L383.1,202.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M324.3,130.2c-5.8,5.1-13.4,7.5-13.4,7.5s2.5,4.5,2.5,9.2c7.4-1.9,12.9-5.4,16.8-9.1L324.3,130.2z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "362.1,349.1 377.6,329.4 379.7,355.6  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "286.3,292.6 305.3,308.9 279.2,309.9  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "462.1,61 477.7,41.3 479.7,67.4  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "434.8,430 442.9,420.7 446.5,430  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "473,325.5 474.8,312.8 481.8,319.2  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "311.9,308.3 313.7,295.6 320.6,301.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "316.4,221.4 318.3,208.7 325.2,215.1  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "283.3,202.6 285.1,189.9 292,196.3  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "283.4,431.7 272.1,425.6 283.4,413  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "453.5,403.7 442.3,397.6 461.6,391.6  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "181,308 169.8,301.9 189.1,295.9  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "465.4,289.8 454.1,283.7 473.5,277.7  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "426.7,242.6 415.4,236.5 434.8,230.5  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M229.8,244.9c0,0-12.3-4.3-16-19.5c3.4,0,6.6-2,6.6-2s5.1,16.4,15.5,14.9 C235.3,240.9,229.8,244.9,229.8,244.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.9,218c0,0,3.5-8.2,14-10c-0.1,2.3,1.1,4.6,1.1,4.6s-11.4,2.7-10.9,9.9 C159.4,221.9,156.9,218,156.9,218z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M278.3,170.5c0,0,3.5-8.2,14-10c-0.1,2.3,1.1,4.6,1.1,4.6s-11.4,2.7-10.9,9.9 C280.8,174.5,278.3,170.5,278.3,170.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M353,238.4c0,0,19.7,6.7,27.6,30.2c2.1-0.8,4.7-1.6,7.4-1.6c-6.9-26.8-28.7-34.2-28.7-34.2 s-4.1,3-7.2,6.4C352.6,238.7,353,238.4,353,238.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.2,142.6c0,0,3.7,6.4,6.3,7.2c-0.3-4.6,2.3-8.1,5.5-10.7l-4.3-6.3 C168.4,137.4,166.2,142.6,166.2,142.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.3,179.1c0,0-5.2,7.6-4.8,11c5.1-2.8,10.4-1.7,15,0.6l4.8-8.2C325.2,178.8,318.3,179.1,318.3,179.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M268.7,157.8c4.8-3.8,11.1-5.4,11.1-5.4s-1.8-3.7-1.5-7.4c-6,1.1-10.5,3.7-13.8,6.5L268.7,157.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M415.7,284.1c4.8-3.8,11.1-5.4,11.1-5.4s-1.8-3.7-1.5-7.4c-6,1.1-10.5,3.7-13.8,6.5L415.7,284.1z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "276,215.5 259.4,234.2 258.9,208  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "180.2,97.2 173.3,104.3 170.8,96.7  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "501,-8.3 494.1,-1.3 491.6,-8.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "192.1,242.1 190.1,252.2 184.9,246.8  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "272,260.8 269.5,273.3 262.9,266.6  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "355.8,157.5 366.6,164.2 354.7,176.1  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "216.2,191.6 224.9,197 209.2,200.9  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "187.6,352.5 196.3,357.9 180.6,361.8  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "429.1,13.9 437.8,19.3 422.1,23.1  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "347.7,335 356.4,340.4 340.7,344.2  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M259.4,8.2c0,0,12.7,10.2,10.8,29.6c-4-1.3-8.7-0.3-8.7-0.3s0.8-21.5-12.2-24 C251.2,10.7,259.4,8.2,259.4,8.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M335.7,86.2c0,0-7.5,8.2-20.7,6c1.1-2.7,0.6-5.9,0.6-5.9s14.6,1.6,16.9-7.2 C334.4,80.5,335.7,86.2,335.7,86.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.1,242.4c0,0,11.5-8.6,27.5-2.7c-2,3.1-2.2,7.3-2.2,7.3s-18.1-5.4-23.1,5.1 C116.4,249.9,116.1,242.4,116.1,242.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.2,274.6c0,0,11.5-8.6,27.5-2.7c-2,3.1-2.2,7.3-2.2,7.3s-18.1-5.4-23.1,5.1 C210.5,282.1,210.2,274.6,210.2,274.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M482.6,140.1c0,0,11.5-8.6,27.5-2.7c-2,3.1-2.2,7.3-2.2,7.3s-18.1-5.4-23.1,5.1 C482.8,147.6,482.6,140.1,482.6,140.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M397.2,372.6c0,0-2.4-14.1,10.1-25.8c1.9,3.2,5.5,5.3,5.5,5.3s-13,13.7-5.9,22.9 C404,375.8,397.2,372.6,397.2,372.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M403.3,134.6c0,0-18.2-14.2-15.8-41.8c5.7,1.8,12.3,0.3,12.3,0.3s-0.8,30.5,17.7,33.8 C414.9,131,403.3,134.6,403.3,134.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M500.7,218.3c0,0-18.2-14.2-15.8-41.8c5.7,1.8,12.3,0.3,12.3,0.3s-0.8,30.5,17.7,33.8 C512.3,214.7,500.7,218.3,500.7,218.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.5,123.8c0,0-1.7-9-4.5-11.2c-1.6,5.6-6.1,8.7-10.9,10.3l2.5,9.2C288.9,129,293.5,123.8,293.5,123.8z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M329.5-19.7c0,0-1.7-9-4.5-11.2c-1.6,5.6-6.1,8.7-10.9,10.3l2.5,9.2C324.9-14.5,329.5-19.7,329.5-19.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.8,36.9c0,0,7.4-5.4,8.2-8.8c-5.7,1-10.4-1.8-14-5.5l-7.3,6.1C236.1,35,242.8,36.9,242.8,36.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.1,107.9c-5.8,2-12.2,1.4-12.2,1.4s0.5,4.1-1,7.5c6,0.9,11.1-0.1,15.2-1.6L215.1,107.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M291.5-37.7c-5.8,2-12.2,1.4-12.2,1.4s0.5,4.1-1,7.5c6,0.9,11.1-0.1,15.2-1.6L291.5-37.7z"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "238.8,130.5 247.6,126.2 247.4,134.2  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "310,54.4 316.5,43.4 320.5,51.9  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "185.6,-15.6 192.1,-26.6 196.1,-18.1  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.7,182.2 114.7,172.3 129.9,165  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "462.6,236.3 454.6,226.3 469.8,219.1  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "241.2,68.8 233.1,58.9 253.3,60.7  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "377.8,61.8 383,54.5 377.7,47.2 386.3,49.9 391.5,42.6 391.6,51.6 400.2,54.3 391.6,57.2  391.7,66.2 386.3,58.9  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "484.1,275.3 492.6,272.1 492.2,263.1 497.8,270.2 506.3,267.1 501.3,274.6 506.8,281.7  498.1,279.2 493.1,286.7 492.8,277.7  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "213.7,320.6 219.5,318.4 219.3,312.2 223.1,317.1 229,315 225.5,320.1 229.4,325 223.4,323.3  219.9,328.5 219.7,322.3  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "404.9,201.1 410.8,199 410.5,192.7 414.4,197.6 420.2,195.5 416.8,200.7 420.6,205.6  414.6,203.9 411.1,209 410.9,202.8  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "68.7,196.5 74.5,194.3 74.3,188.1 78.1,193 84,190.8 80.5,196 84.4,200.9 78.4,199.2 74.9,204.4  74.7,198.2  "
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "168.3,246.4 163.5,242.5 173.2,241.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "139.6,320.7 144.6,317.2 143,326.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "139.8,157 144.8,153.5 143.3,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "187.7,299.1 187.3,294.6 192.3,299.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 278.5,
    transform: "matrix(0.9446 -0.3281 0.3281 0.9446 -85.2816 62.0422)",
    className: "st6",
    width: 4.4,
    height: 10.5
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "391,148.6 395.5,151.7 387,153.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "433.9,-13.5 438.4,-10.4 429.9,-8.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "411.7,79.8 407.5,83.3 408.2,74.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "445.4,32.7 441.2,36.2 441.9,27.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "422.8,227 418.5,230.5 419.2,221.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "369.9,102.6 370.6,106.6 365.8,102.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.8,
    y: 108.4,
    transform: "matrix(0.917 -0.3989 0.3989 0.917 -10.857 174.0556)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.8,
    y: 25.2,
    transform: "matrix(0.9894 -0.1451 0.1451 0.9894 0.1522 56.3747)",
    className: "st11",
    width: 9.4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "462.1,262.4 457.1,253.9 465.8,252.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "398.7,408.4 394.4,405 403.1,403.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "427.9,317.1 432.4,313.9 431,322.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "390.7,361.5 395.2,358.3 393.8,366.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "428.1,169.5 432.6,166.3 431.3,174.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "471.3,297.6 471,293.5 475.4,297.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 279.1,
    transform: "matrix(0.9447 -0.328 0.328 0.9447 -69.3241 156.5293)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.3,
    y: 369.5,
    transform: "matrix(0.9976 -6.939923e-02 6.939923e-02 0.9976 -24.6986 32.056)",
    className: "st11",
    width: 9.4,
    height: 4
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "308.1,141.9 312.6,145 304,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "344.6,-25 346.4,-57.5 337.8,-55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "328.8,73 324.5,76.6 325.3,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "357.5,53.7 353.2,57.2 354,48.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "339.8,220.2 335.6,223.8 336.3,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "287,95.8 287.6,99.8 282.9,95.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.9,
    y: 101.7,
    transform: "matrix(0.917 -0.3988 0.3988 0.917 -15.0563 140.381)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.8,
    y: 0.7,
    transform: "matrix(0.9894 -0.1451 0.1451 0.9894 2.7202 42.623)",
    className: "st11",
    width: 9.4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "383.7,235 379.4,231.5 388.1,230.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "315.8,401.7 311.5,398.2 320.2,397.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "345,310.4 349.5,307.2 348.1,315.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "307.8,354.8 312.3,351.6 310.9,360.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "345.2,162.8 349.7,159.6 348.3,168.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "388.4,290.8 388,286.8 392.5,291.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 272.3,
    transform: "matrix(0.9447 -0.328 0.328 0.9447 -71.7054 128.9576)",
    className: "st6",
    width: 4,
    height: 9.4
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "227.2,136.1 231.3,139.8 222.6,140.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "288.9,-19.8 293.1,-16.1 284.3,-15.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "249.5,217.7 244.8,220.7 246.6,212.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.7,87.9 211.9,92 207.6,87.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.1,
    y: 98.8,
    transform: "matrix(0.9576 -0.2881 0.2881 0.9576 -19.0848 77.2881)",
    className: "st6",
    width: 4,
    height: 9.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "277.6,244.3 273.8,240.3 282.5,240.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.2,395.1 200.3,391.1 209.1,391.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "244,307.8 248.8,305.2 246.4,313.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "201.8,347.5 206.7,344.9 204.3,353.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "267.9,179.7 272.7,177 270.3,185.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "289.4,293.5 289.5,289.5 293.5,294.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 270.2,
    transform: "matrix(0.9768 -0.2143 0.2143 0.9768 -53.1186 59.8261)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 359.6,
    transform: "matrix(4.860089e-02 -0.9988 0.9988 4.860089e-02 -117.8971 604.8045)",
    className: "st11",
    width: 4,
    height: 9.4
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "321,153.7 317.8,158.3 316.1,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "483.1,196.6 480,201.2 478.3,192.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "376.2,159.6 372.7,155.3 381.4,156.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "436.9,208.2 433.4,203.9 442.1,204.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "242.6,185.5 239.1,181.2 247.8,182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "365,119.5 361,120.2 364.9,115.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 173.6,
    transform: "matrix(0.917 -0.3989 0.3989 0.917 -40.4394 156.7633)",
    className: "st6",
    width: 9.4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 143.9,
    transform: "matrix(0.9894 -0.1452 0.1452 0.9894 -16.6106 69.5973)",
    className: "st11",
    width: 4,
    height: 9.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "219.5,216.6 223,212.3 224,221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,161.4 64.6,157.1 65.6,165.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "152.5,190.6 155.7,195.2 147,193.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "108.1,153.4 111.3,158 102.6,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "300.1,190.9 303.3,195.4 294.6,194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "172,234.1 176,233.7 171.8,238.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 190.1,
    transform: "matrix(0.9447 -0.328 0.328 0.9447 -52.7397 71.5686)",
    className: "st6",
    width: 9.4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 207,
    transform: "matrix(0.9976 -6.949875e-02 6.949875e-02 0.9976 -14.4788 7.3273)",
    className: "st11",
    width: 4,
    height: 9.4
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "424.1,160.5 428.5,163.8 419.9,165.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "470.2,-0.7 474.7,2.5 466,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "454.9,98.1 450.5,101.5 451.4,92.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "480.8,45.7 476.5,49.2 477.4,40.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "454.2,239.5 449.9,243 450.8,234.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "403.9,114.1 404.5,118.1 399.8,114.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.6,
    y: 120.8,
    transform: "matrix(0.9247 -0.3806 0.3806 0.9247 -14.1511 179.4129)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.3,
    y: 37,
    transform: "matrix(0.9921 -0.1256 0.1256 0.9921 -1.5597 53.3134)",
    className: "st11",
    width: 9.4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "480.5,250 476.3,246.5 485,245.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "426.6,420.5 422.3,416.9 431.1,416.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "457.6,329.7 462.2,326.6 460.6,335.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "419.5,373.4 424.1,370.3 422.5,378.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "460.8,182.2 465.3,179.1 463.8,187.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "501.4,311.1 501.1,307 505.5,311.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.7,
    y: 291.7,
    transform: "matrix(0.9511 -0.309 0.309 0.9511 -69.1068 156.5561)",
    className: "st6",
    width: 4,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.9,
    y: 382.6,
    transform: "matrix(0.9988 -4.949872e-02 4.949872e-02 0.9988 -18.4491 24.1123)",
    className: "st11",
    width: 9.4,
    height: 4
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "404.9,222.5 398.6,219.1 411.2,217.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "332.9,385.8 326.6,382.3 335.1,375.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "380.1,279.6 386.6,276.4 384.7,285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "326.7,324.4 333.3,321.2 331.4,329.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "377.8,132 384.3,128.8 382.5,137.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "442.8,259.5 442.3,255.5 448.8,259.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "415.3,258.8 409.9,260.1 405.2,251.3 410.7,249.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "405.1,336.1 404.6,332.1 418.3,331.4 418.8,335.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "334.9,107 340.8,110.7 328.1,111.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "455.3,-55.4 461.2,-51.7 448.5,-51.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "378.8,41.7 371.9,44.6 374.8,36.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "436.9,-0.2 430.1,2.7 432.9,-5.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "364.7,189 357.8,191.9 360.6,183.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "314,58.4 314.1,62.5 308,57.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "368.9,70.9 374.5,69.8 378.1,78.9 372.6,80  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "360.1,-15.9 360.1,-11.9 346.4,-11.9 346.4,-15.9  "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupomConfetti);
export default __webpack_public_path__ + "static/media/cupom-confetti.e12c14dce5a0599c1aed134021928c8f.svg";
export { ForwardRef as ReactComponent };